import { nanoid } from 'nanoid'
import { AppHTTPService } from '../http-service'

export const getEntitlements = async (params: { resourceId: string | undefined }): Promise<any> => {
  if (params.resourceId) {
    return AppHTTPService.axios.get('/v1/entitlements', { params }).then((res) => {
      // Add unique IDs to each entitlement using nanoid and ensure we return in the format expected by the resource system
      const entitlementsWithIds = (res.data.data || []).map((ent: any) => ({
        ...ent,
        id: `ent_${nanoid()}`, // Generate a truly unique ID with nanoid
      }))

      return {
        data: entitlementsWithIds,
      }
    })
  }
  return { data: [] }
}
